import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { OfferOutputDto, OfferService } from 'src/generated_client';

@Component({
  selector: 'app-discounts-management',
  templateUrl: './discounts-management.component.html',
  styleUrls: ['./discounts-management.component.css']
})
export class DiscountsManagementComponent implements OnInit {

  displayedColumns: string[] = ['code', 'value', 'status', 'options'];
  dataSource: any = [];
  storeId: number = 0;

  constructor(
    public offerService: OfferService,
    public authService: AuthService,
    private router: Router,
    private snack: SnackBarService
  ) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    let store = this.authService.currentUserStore();
    this.storeId = Number(store.cdStore);
    this.getOffers();
  }

  getOffers() {
    this.offerService.apiOfferGetallItemOffersGet(this.storeId).subscribe(x => {
      this.dataSource = x;
    }, err => {
      this.snack.openSnackBar('Ocurrio un problema y no pudo cargarse', 'Aceptar');
    })
  }

  editDiscount(id: number) {
    this.router.navigate(['edit-store-discount', id]);
  }

  addDiscount() {
    this.router.navigate(['add-store-discount']);
  }

  enableDisable(id: number, status: boolean) {
    if (status) {
      this.DisableOffer(id);
      this.snack.openSnackBar('Se desactivó el descuento', 'Acepar')
    }
    else {
      this.EnableOffer(id);
      this.snack.openSnackBar('Se activó el descuento', 'Acepar')
    }
  }

  deleteDiscount(id: number) {
    this.offerService.apiOfferDeleteOfferDelete(id).subscribe(() => {
      this.router.navigate(['store-discount']);
      this.snack.openSnackBar('El descuento fue eliminado', 'Aceptar');
    },
      err => {
        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }

  EnableOffer(id: number) {
    this.offerService.apiOfferEnableOfferPut(id).subscribe(() => {
      this.router.navigate(['store-discount']);
    },
      err => {
        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }

  DisableOffer(id: number) {
    this.offerService.apiOfferDisableOfferPut(id).subscribe(() => {
      this.router.navigate(['store-discount']);
    },
      err => {
        this.snack.openSnackBar(err.error.error, 'Aceptar');
      }
    );
  }
}